import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import { Markup } from "interweave";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert";
import { Link, useHistory, useParams } from "react-router-dom";
import noImage from "../../../../../assets/images/settings/no-image.png";
import { Modal, Button } from "react-bootstrap";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../../Reuseable/LoaderPost";
// import './SouvenirMain.css'
// import StarShowcaseModal from "./StarShowcaseModal/StarShowcaseModal";
// import noImage from "../../../../../../";

const PrmotionalVideoView = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const { id } = useParams();

  const { history } = useHistory();

  const [promotionalView, setPromotionalView] = useState({});

  const [loading, setloading] = useState(true);
  const [promotionalStatus, setPromotionalStatus] = useState(0);
  const [promotionalAuditionId, setPromotionalAuditionId] = useState();
  const [promotionalAuditionCheck, setPromotionalAuditionCheck] = useState(0);
  // const [modalShowl, setModalShowl] = useState(false);

  // const {pdfFile} = promotionalView?.document;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const downloadPdf =()=>{
  //     alert(`${pdfFile}`);
  //     history.push(`${pdfFile}`);
  // }

  useEffect(() => {
    axios
      .get(`/api/superstar/audition/promotional/video/view/${parseInt(id)}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPromotionalView(res.data?.eventView);
          setPromotionalStatus(res.data?.eventView.status);
          setPromotionalAuditionId(res.data?.eventView?.audition_id);
          // setStatus(res.data.action)
          setloading(false);
        }
      });
  }, [id]);

  useEffect(() => {
    axios
      .get(
        `/api/superstar/audition/promotional/video/check/${parseInt(
          promotionalAuditionId
        )}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setPromotionalAuditionCheck(1);
        } else {
          setPromotionalAuditionCheck(2);
        }
      });
  }, [promotionalAuditionId]);

  const handleApprove = (data) => {
    axios
      .get(
        `/api/superstar/audition/promotional/video/accepted/${parseInt(data)}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setPromotionalStatus(1);
          swal("Success", res.data.message, "success");
        }
      });
  };
  const handleDecline = (data) => {
    axios
      .get(
        `/api/superstar/audition/promotional/video/declined/${parseInt(data)}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setPromotionalStatus(2);
          swal("Success", res.data.message, "success");
        }
      });
  };

  return (
    <>
      {loading ? (
        <LoaderPost />
      ) : (
        <>
          <div className="m-3">
            <div className="card ">
              <img
                src={
                  promotionalView?.image
                    ? imageCdnUrl + promotionalView?.image
                    : noImage
                }
                alt=""
                className="BannerAGN"
              />
            </div>
            <div className="mt-3 row">
              <div className="col-md-8 ">
                <div className="row LeftGNA">
                  <div className="NotifyOver w-100 mb-5">
                    <h2
                      style={{
                        color: "gold",
                        fontSize: "20px",
                        fontWeight: "700",
                        padding: "15px 0",
                      }}
                    >
                      Promotional Instruction
                    </h2>
                    <p className="text-light pt-1">
                      <Markup content={promotionalView?.instruction} />
                    </p>
                  </div>
                  <div className="NotifyOver w-100 mb-5">
                    <h2
                      style={{
                        color: "gold",
                        fontSize: "20px",
                        fontWeight: "700",
                        padding: "15px 0",
                      }}
                    >
                      Promotional Description
                    </h2>
                    <p className="text-light pt-1">
                      <Markup content={promotionalView?.description} />
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <ReactPlayer
                  className="ReactNAv"
                  url={
                    promotionalView?.video
                      ? videoCdnUrl + promotionalView?.video
                      : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                  }
                  width="100%"
                  // height="100%"
                  playing={false}
                  volume={1}
                  controls={true}
                  autoPlay
                />
                <div className="card card-bg px-3 py-4">
                  <p className="text-light pt-1">
                    {promotionalStatus === 0 ? (
                      <>
                        <button
                          className="btn  btn-info w-50"
                          onClick={() => handleApprove(promotionalView?.id)}
                        >
                          Approved
                        </button>
                        <button
                          className="btn btn-danger w-50"
                          onClick={() => handleDecline(promotionalView?.id)}
                        >
                          Declined
                        </button>
                      </>
                    ) : promotionalStatus === 1 ? (
                      promotionalAuditionCheck === 1 ? (
                        <button className="btn btn-info w-100">
                          <i className="fa-solid fa-check"></i> Promotional
                          Video Submitted
                        </button>
                      ) : (
                        <>
                          <Link
                            to={`/superstar/audition/promotional-post/${promotionalView?.audition_id}`}
                            className="btn BlueBtn w-100"
                          >
                            <span className="child-cat">
                              <i className="fa-solid fa-plus"></i> Add
                              Promotional Video
                            </span>
                          </Link>
                        </>
                      )
                    ) : (
                      <button className="btn btn-danger w-100">
                        !! Declined
                      </button>
                    )}

                    {/* <Link to={ serverUrl + promotionalView?.document  }>        */}
                    {/* <button  className="btn BlueBtn w-100" onClick={downloadPdf}>Download</button> */}
                    {/* </Link> */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PrmotionalVideoView;
